import api from '../api/axios';

export interface SectionFDetail {
  id: number;
  organization_id: number;
  project_id: number;

  // F.1 A6.4 機制確認
  a64_not_registered:     boolean;
  a64_not_included_as_cp: boolean;
  a64_not_deregistered:   boolean;
  a64_was_excluded_cp:    boolean;
  a64_exclusion_details:  string | null;

  // F.2 其他機制確認
  other_crediting_status:     number | null;  // 1/2/3, null=未選擇
  other_confirmation_details: string | null;

  section_f:  number;
  edit_by:    number | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface SectionFUpdate {
  a64_not_registered?:     boolean;
  a64_not_included_as_cp?: boolean;
  a64_not_deregistered?:   boolean;
  a64_was_excluded_cp?:    boolean;
  a64_exclusion_details?:  string | null;
  other_crediting_status?:     number | null;
  other_confirmation_details?: string | null;
}

const BASE_URL = '/api/section-f';

const sectionFService = {
  getSectionFByProject: async (projectId: number): Promise<SectionFDetail | null> => {
    const res = await api.get<SectionFDetail | null>(`${BASE_URL}/by-project/${projectId}`);
    return res.data;
  },

  saveSectionF: async (projectId: number, data: SectionFUpdate): Promise<SectionFDetail> => {
    const res = await api.put<SectionFDetail>(`${BASE_URL}/${projectId}`, data);
    return res.data;
  },

  resetSectionF: async (projectId: number): Promise<void> => {
    await api.post(`${BASE_URL}/${projectId}/reset`);
  },
};

export default sectionFService;
